var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurnitureLivingroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.75C6.88807 3.75 7 3.63807 7 3.5C7 3.36193 6.88807 3.25 6.75 3.25C6.61193 3.25 6.5 3.36193 6.5 3.5C6.5 3.63807 6.61193 3.75 6.75 3.75Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.75C9.38807 3.75 9.5 3.63807 9.5 3.5C9.5 3.36193 9.38807 3.25 9.25 3.25C9.11193 3.25 9 3.36193 9 3.5C9 3.63807 9.11193 3.75 9.25 3.75Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 6.25C9.38807 6.25 9.5 6.13807 9.5 6C9.5 5.86193 9.38807 5.75 9.25 5.75C9.11193 5.75 9 5.86193 9 6C9 6.13807 9.11193 6.25 9.25 6.25Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.25C6.88807 6.25 7 6.13807 7 6C7 5.86193 6.88807 5.75 6.75 5.75C6.61193 5.75 6.5 5.86193 6.5 6C6.5 6.13807 6.61193 6.25 6.75 6.25Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.25V3.5C2.25 1.705 4.82437 0.25 8 0.25C11.1756 0.25 13.75 1.705 13.75 3.5V4.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.75V13.75C2.25 13.8826 2.30268 14.0098 2.39645 14.1036C2.49021 14.1973 2.61739 14.25 2.75 14.25H13.25C13.3826 14.25 13.5098 14.1973 13.6036 14.1036C13.6973 14.0098 13.75 13.8826 13.75 13.75V9.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.68747C2.34618 9.79173 1.91986 9.76715 1.53071 9.61715C1.14155 9.46716 0.809015 9.19925 0.579639 8.85093C0.350264 8.5026 0.23552 8.09128 0.251462 7.67452C0.267405 7.25776 0.413237 6.85641 0.668553 6.52663C0.923869 6.19685 1.2759 5.95513 1.67538 5.8353C2.07486 5.71547 2.5018 5.72353 2.89648 5.85834C3.29116 5.99315 3.63381 6.24798 3.87651 6.58716C4.1192 6.92634 4.24979 7.3329 4.25 7.74997V10.75C4.25 10.9489 4.32902 11.1396 4.46967 11.2803C4.61032 11.421 4.80109 11.5 5 11.5H11C11.1989 11.5 11.3897 11.421 11.5303 11.2803C11.671 11.1396 11.75 10.9489 11.75 10.75V7.74997C11.7502 7.3329 11.8808 6.92634 12.1235 6.58716C12.3662 6.24798 12.7088 5.99315 13.1035 5.85834C13.4982 5.72353 13.9251 5.71547 14.3246 5.8353C14.7241 5.95513 15.0761 6.19685 15.3314 6.52663C15.5868 6.85641 15.7326 7.25776 15.7485 7.67452C15.7645 8.09128 15.6497 8.5026 15.4204 8.85093C15.191 9.19925 14.8585 9.46716 14.4693 9.61715C14.0801 9.76715 13.6538 9.79173 13.25 9.68747",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.25C5.47456 8.92913 6.73415 8.76118 8 8.75C9.26585 8.76118 10.5254 8.92913 11.75 9.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 15.25V15.5C3.25 15.5663 3.27634 15.6299 3.32322 15.6768C3.37011 15.7237 3.4337 15.75 3.5 15.75H5C5.0663 15.75 5.12989 15.7237 5.17678 15.6768C5.22366 15.6299 5.25 15.5663 5.25 15.5V15.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 15.25V15.5C10.75 15.5663 10.7763 15.6299 10.8232 15.6768C10.8701 15.7237 10.9337 15.75 11 15.75H12.5C12.5663 15.75 12.6299 15.7237 12.6768 15.6768C12.7237 15.6299 12.75 15.5663 12.75 15.5V15.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureLivingroom);
export default __webpack_public_path__ + "static/media/furniture-living room.2e232462.svg";
export { ForwardRef as ReactComponent };